import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import React, { useContext, useState } from 'react'
import Navigation from '@App/navigation'
import ModalPortal from '@Components/Popups/ModalPortal'
import { StoresContext } from '@App/contexts'
import DeleteSongwriterPopup from '@Components/Popups/DeleteSongwriterPopup'

const SongwriterSummaryCard = ({ id, name, totalWorks }: SongwriterSummary) => {
    const [displayDeletePopup, setDisplayPopup] = useState<boolean>(false)
    const { userStore } = useContext(StoresContext)

    return (
        <div className="rightsholder-summary-card-wrapper">
            <ModalPortal isOpen={displayDeletePopup}>
                <DeleteSongwriterPopup id={id} totalWorks={totalWorks} setDisplayPopup={setDisplayPopup} />
            </ModalPortal>
            <div className="name-block">
                <h4 title={name}>{name}</h4>
                {!userStore.isInternal && (
                    <Button
                        className="delete-songwriter-button"
                        mainColor
                        type="tertiary"
                        onClick={() => setDisplayPopup(true)}
                        onlyIcon
                        icon={ICONS.trashCan}
                    />
                )}
            </div>
            <div className="info-line">
                <div>
                    <h1 className="blue-text">{totalWorks.toLocaleString()}</h1>
                    <p className="small">Total Songs</p>
                </div>
            </div>
            <Button
                typeLink
                linkTo={Navigation.songwriter.catalog.root(id)}
                mainColor
                type="primary"
                icon={ICONS.arrow_forward}
            >
                View My Catalog
            </Button>
        </div>
    )
}

export default SongwriterSummaryCard
